// DialogBudgetExpenseAdd Component

/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Input from '../../../common/form/input/input.jsx'
import InputPrice from '../../../common/form/input_price/input_price.jsx'
import FormAutoComplete from '../../../common/form/auto_complete/auto_complete.jsx'
import Select from '../../../common/form/select/select.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class DialogBudgetExpenseAdd extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      contactId: props.contactId || '',
      projectId: props.projectId || '',
      title: '',
      description: '',
      contactName: props.contactName || '',
      displayContactName: props.contactName || '',
      rateMarkup: 0,
      checked: false,
      total: '',
      sellingPrice: '',
      phaseNo: 1,
      showError: false,
      dataDate: null,
      selectedBudgetItem: null,
      displayBudgetItemTitle: '',
      fromDate: null,
      toDate: null
    }

    this.data = {
      contacts: [],
      projects: [],
      phases: [],
      budgetItems: [],
      bHideDrop: false
    }

    this._references = {
      inputContact: React.createRef(),
      selectProject: React.createRef(),
      inputBudgetItem: React.createRef(),
      inputTotal: React.createRef()
    }

    this._bContactSearchPending = null
    this._contactSearchKeyword = ''
    this._bBudgetSearchPending = null
    this._budgetSearchKeyword = ''
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      contactSearch: PropTypes.func,
      getProjects: PropTypes.func,
      onSearchBudgetItem: PropTypes.func,
      onSelect: PropTypes.func,
      onCreate: PropTypes.func,
      prefixCurrency: PropTypes.string,
      contactName: PropTypes.string,
      contactId: PropTypes.string,
      projectId: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      contactSearch: null,
      getProjects: null,
      onSearchBudgetItem: null,
      onSelect: null,
      onCreate: null,
      prefixCurrency: '',
      contactName: '',
      contactId: null,
      projectId: null
    }
  }

  show () {
    if (
      this.props.projectId &&
      this.props.contactId &&
      this.props.getProjects
    ) {
      this.props.getProjects(this.props.contactId, obj => {
        this.data.projects = obj
        this._onChangeProject(this.props.projectId)
      })
    }

    this.setState({ active: true })
  }

  hide () {
    this.data.budgetItems = []
    this.data.bHideDrop = false

    this.setState({
      active: false,
      contactId: this.props.contactId || '',
      projectId: this.props.projectId || '',
      title: '',
      description: '',
      contactName: this.props.contactName || '',
      displayContactName: this.props.contactName || '',
      rateMarkup: 0,
      checked: false,
      total: 0,
      sellingPrice: 0,
      phaseNo: 1,
      showError: false,
      dataDate: null,
      selectedBudgetItem: null,
      displayBudgetItemTitle: ''
    })

    if (this._references.selectProject.current) {
      this._references.selectProject.current.clearError()
    }
    if (this._references.inputContact.current) {
      this._references.inputContact.current.hideAdd()
      this._references.inputContact.current.clearError()
    }
    if (this._references.inputBudgetItem.current) {
      this._references.inputBudgetItem.current.hideAdd()
      this._references.inputBudgetItem.current.clearError()
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = ev => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  }

  render () {
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'
    const bAddNew = !this.state.selectedBudgetItem

    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        type='medium'
      >
        <div className='dialog-form dialog-budgetexpense'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='expense.form.addBudgetTitle' />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='expense.form.addBudgetErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormAutoComplete
                          label='expense.form.labelClient'
                          ref={this._references.inputContact}
                          validations={['required']}
                          name='contactId'
                          value={this.state.contactId}
                          displayValue={this.state.displayContactName}
                          options={this.data.contacts}
                          onChange={this._handleSearchContact.bind(this)}
                          onSelect={this._handleContactSelect.bind(
                            this,
                            'contactId'
                          )}
                          hideAdd
                          hasAutoSelect
                        />
                      </div>
                    </div>
                    {this.data.bHideDrop ? (
                      <div className='formrow'>
                        <div className='formcol'>
                          <span className='norecrds'>
                            <IntlMessage ident='expense.form.noProjectFound' />
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Select
                            options={this.data.projects}
                            name='projectId'
                            label='expense.form.labelProject'
                            ref={this._references.selectProject}
                            value={this.state.projectId}
                            className='form-dropdown'
                            onChange={this._onChangeProject.bind(this)}
                          />
                        </div>
                      </div>
                    )}
                    {this.state.projectId &&
                    this.data.phases &&
                    this.data.phases.length > 1 ? (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Select
                            options={this.data.phases}
                            name='phaseNo'
                            label='expense.form.labelPhase'
                            value={this.state.phaseNo}
                            className='form-dropdown'
                            validations={['required']}
                            onChange={this._onChangeInput.bind(this, 'phaseNo')}
                          />
                        </div>
                      </div>
                    ) : null}
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormAutoComplete
                          label='expense.form.expenseActivity'
                          name='selectedBudgetItem'
                          ref={this._references.inputBudgetItem}
                          validations={['required']}
                          value=''
                          displayValue={this.state.displayBudgetItemTitle}
                          options={this.data.budgetItems}
                          onChange={this._onSearchBudgetItem.bind(
                            this,
                            null,
                            null
                          )}
                          onSelect={this._onSelectBudgetItem.bind(this)}
                          addLabel='expense.form.addNewBudgetItem'
                          errorLabel='expense.form.autocompleteTitle'
                          errorMessage='expense.form.autocompleteMessage'
                          addValue={this.state.title}
                          addName='title'
                          onAddChange={this._onChangeInput.bind(this, 'title')}
                          onToggleAdd={this._onBudgetItemAddToggle.bind(this)}
                          keywordLength={0}
                          hasAutoSelect
                        />
                      </div>
                    </div>
                    {bAddNew && (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Input
                            type='text'
                            name='description'
                            label='expense.form.description'
                            value={this.state.description}
                            styleDotted
                            validations={['required']}
                            size={10}
                            maxLength={100}
                            onChange={this._onChangeInput.bind(
                              this,
                              'description'
                            )}
                          />
                        </div>
                      </div>
                    )}
                    {bAddNew && (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Checkbox
                            icon='common'
                            checked={this.state.checked}
                            className='form-checkbox_alt'
                            label='expense.form.labelAddBudget'
                            onChange={this._onChangeCheckBox.bind(this)}
                          />
                        </div>
                      </div>
                    )}
                    {bAddNew && this.state.checked && (
                      <div className='formrow'>
                        <div className='formcol2'>
                          <InputPrice
                            type='text'
                            name='total'
                            label='expense.form.purchasePrice'
                            ref={this._references.inputTotal}
                            value={this.state.total}
                            prefixCurrency={this.props.prefixCurrency}
                            validations={['required']}
                            size={10}
                            maxLength={100}
                            onChange={this._onChangeInput.bind(this, 'total')}
                            onBlur={this._onBlurInput.bind(this, 'total')}
                          />
                        </div>
                        <div className='formcol2'>
                          <InputPrice
                            type='text'
                            name='sellingPrice'
                            label='expense.form.sellingPrice'
                            styleDotted
                            prefixCurrency={this.props.prefixCurrency}
                            value={this.state.sellingPrice}
                            validations={['required']}
                            size={10}
                            maxLength={100}
                            onChange={this._onChangeInput.bind(
                              this,
                              'sellingPrice'
                            )}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              canHover={false}
              title='expense.form.addBudgetExpense'
              onClick={this._onFormSubmit.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onFormSubmit (ev) {
    ev.preventDefault()
    let noErrors = 0

    if (
      this._references.selectProject.current &&
      !this._references.selectProject.current.validate()
    ) {
      noErrors++
    }

    if (this.state.checked) {
      if (
        this._references.inputTotal.current &&
        !this._references.inputTotal.current.validate()
      ) {
        noErrors++
      }
    }

    if (!this.state.title) {
      if (
        this._references.inputBudgetItem.current &&
        !this._references.inputBudgetItem.current.validate()
      ) {
        noErrors++
      }
    }

    if (noErrors === 0) {
      if (this.state.selectedBudgetItem) {
        if (this.props.onSelect) {
          this.props.onSelect(this.state.selectedBudgetItem)
        }
      } else {
        const expBudgetObj = {
          contactId: this.state.contactId,
          projectId: this.state.projectId,
          title: this.state.title,
          description: this.state.description,
          total: this.state.total,
          sellingPrice: this.state.sellingPrice,
          phaseNo: this.state.phaseNo,
          markupPercentage: this.state.rateMarkup,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate
        }

        if (this.props.onCreate) {
          this.props.onCreate(expBudgetObj)
        }
      }
    } else {
      this.setState({ showError: true })
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onChangeInput (name, value) {
    if (name === 'phaseNo') {
      const projectDates = this._getProjectPhaseDates(value)
      this.setState({
        [name]: value,
        fromDate: projectDates.fromDate,
        toDate: projectDates.toDate
      })
      this._onSearchBudgetItem(this.state.projectId, value, '')
    } else if (name === 'projectId') {
      this.setState({ [name]: value })
      this._onSearchBudgetItem(value, this.state.phaseNo, '')
    } else {
      this.setState({ [name]: value })
    }
  }

  _onBlurInput (name, _ev) {
    if (name === 'total') {
      const total = parseFloat(this.state.total)
      let sellingPrice = total

      if (this.state.rateMarkup > 0) {
        sellingPrice = total + total * (this.state.rateMarkup / 100)
      }

      this.setState({ sellingPrice: sellingPrice, dataDate: new Date() })
    }
  }

  _getProjectPhaseDates (phaseNo) {
    const { projectId } = this.state
    const projectObj = _.find(
      this.data.projects,
      project => project.value === projectId
    )

    let fromDate = null
    let toDate = null
    if (projectObj.phases && projectObj.phases.length > 0) {
      projectObj.phases.forEach((phase, _idx) => {
        if (phase.phaseNo === phaseNo) {
          fromDate = phase.fromDate
          toDate = phase.toDate
        }
      })
    }

    return { fromDate, toDate }
  }

  _onChangeProject (projectId) {
    const projectObj = _.find(
      this.data.projects,
      project => project.value === projectId
    )
    this.data.phases = []
    let fromDate = null
    let toDate = null

    if (projectObj.phases && projectObj.phases.length > 0) {
      projectObj.phases.map((phase, idx) => {
        if (phase.status !== 'closed' && phase.status !== 'estimate') {
          let phaseTitle = phase.title
          const phaseNo = idx + 1

          if (!phaseTitle) {
            phaseTitle = `${IntlUtil.convertMessage(
              'expense.form.phaseLabel'
            )} ${phaseNo}`
          }

          this.data.phases.push({ label: phaseTitle, value: phaseNo })
        }
      })
    }

    // If has only one phase
    if (this.data.phases.length === 1) {
      const phase = this.data.phases[0]
      if (phase && phase.fromDate && phase.toDate) {
        fromDate = phase.fromDate
        toDate = phase.toDate
      }

      this.setState(
        { projectId: projectId, fromDate, toDate, phaseNo: phase.value },
        () => {
          this._onSearchBudgetItem(this.state.projectId, phase.value, '')
        }
      )
    } else {
      this.setState({ projectId: projectId, fromDate, toDate })
    }

    if (this._references.selectProject.current) {
      this._references.selectProject.current.clearError()
    }
  }

  _onChangeCheckBox (checked) {
    this.setState({ checked: checked })
  }

  _handleSearchContact (keyword) {
    if (keyword) {
      if (this._references.inputContact.current) {
        this._references.inputContact.current.clearError()
      }
    }

    this.setState({ displayContactName: keyword })
    this._processContactSearch(keyword)
  }

  _processContactSearch (keyword) {
    if (keyword.length < 1) return

    if (!this._bContactSearchPending) {
      this._bContactSearchPending = true
      if (this.props.contactSearch) {
        this.props.contactSearch(
          keyword,
          this._onSearchRecieved.bind(this, keyword)
        )
      }
    } else {
      this._contactSearchKeyword = keyword
    }
  }

  _onSearchRecieved (keyword, result) {
    this._bContactSearchPending = false

    this.data.contacts = result
    const stateObj = {}
    if (result && result.length > 0) {
      stateObj.contactId = ''
      stateObj.contactName = keyword
    }

    this.setState(stateObj)

    if (this._contactSearchKeyword) {
      const keyword = this._contactSearchKeyword
      this._contactSearchKeyword = ''
      this._processContactSearch(keyword)
    }
  }

  _handleContactSelect (name, obj) {
    if (obj) {
      this.setState({
        [name]: obj.value,
        displayContactName: obj.label,
        rateMarkup: obj.rateMarkup
      })

      if (this.props.getProjects) {
        this.props.getProjects(obj.value, obj => {
          this.data.projects = obj

          this.data.bHideDrop = false
          if (this.data.projects.length === 0) {
            this.data.bHideDrop = true
          }

          this.data.phases = []
          this.setState({ phaseNo: 1, dataDate: new Date() })
        })
      }
    } else {
      this.data.projects = []
      this.data.bHideDrop = false

      this.setState({ [name]: '' })
    }
  }

  _onSearchBudgetItem (projectId, phaseNo, keyword) {
    this.setState({ displayBudgetItemTitle: keyword })

    if (!this._bBudgetSearchPending) {
      this._bBudgetSearchPending = true
      if (this.props.onSearchBudgetItem) {
        this.props.onSearchBudgetItem(
          projectId || this.state.projectId,
          phaseNo || this.state.phaseNo,
          keyword,
          this._onSearchBudgetRecieved.bind(this, keyword)
        )
      }
    } else {
      this._budgetSearchKeyword = keyword
    }
  }

  _onSearchBudgetRecieved (keyword, options) {
    this._bBudgetSearchPending = false

    this.data.budgetItems = options
    const stateObj = {}
    if (options && options.length > 0) {
      stateObj.selectedBudgetItem = ''
      stateObj.title = keyword
    }

    this.setState(stateObj)

    if (this._budgetSearchKeyword) {
      const keyword = this._budgetSearchKeyword
      this._budgetSearchKeyword = ''
      this._onSearchBudgetItem(null, null, keyword)
    }
  }

  _onSelectBudgetItem (obj) {
    if (obj) {
      this.setState({
        selectedBudgetItem: obj,
        displayBudgetItemTitle: obj.label
      })
    } else {
      this.setState({ selectedBudgetItem: '' })
    }
  }

  _onBudgetItemAddToggle (bAddShown) {
    if (bAddShown) {
      this.setState({
        selectedBudgetItem: null,
        title: this.state.displayBudgetItemTitle
      })
    } else {
      this.setState({ selectedBudgetItem: null, title: '' })
    }
  }
}

export default DialogBudgetExpenseAdd
